import { __decorate } from "tslib";
import { Component, Ref, Vue } from "vue-property-decorator";
import sweetalert from "sweetalert";
import ApiEnter from "@/api/ApiEnter";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import LeftMenuTab from "@/components/LeftMenu/LeftMenuTab.vue";
import PageHeader from "@/components/UI/PageHeader.vue";
import ApiGlossary from "@/api/ApiGlossary";
import DataGlossary from "@/data/CMS/DataGlossary";
import { Getter } from "vuex-class";
import EUserEnum from "@/struct/user/EUserEnum";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import CKEditorConfig from "@/data/CKeditor/config";
import UtilGeneral from "@/util/Common/UtilGeneral";
import RelatedLinksEditor from "@/components/CMS/RelatedLinksEditor.vue";
let Glossary = class Glossary extends Vue {
    constructor() {
        super(...arguments);
        this.Breadcrumbs = DataGlossary.Breadcrumbs;
        this.TableHeaders = DataGlossary.TableHeaders;
        this.TableItems = [];
        this.isOpenDialog = false;
        this.isOpenEditDialog = false;
        this.HasLoading = false;
        this.editor = ClassicEditor;
        this.editorConfig = (() => {
            const cfg = CKEditorConfig.editorConfig(ApiEnter.CurrentSessionUUID);
            cfg.toolbar = {
                items: cfg.toolbar,
                shouldNotGroupWhenFull: true,
            };
            return cfg;
        })();
        this.newUrlTouched = false;
        this.editUrlTouched = false;
        this.newTerm = {
            letter: "",
            term: "",
            definition: "",
            is_advanced: false,
            is_visible: true,
            url: "",
            seo_title: "",
            seo_description: "",
            long_definition: "",
            related_links: [],
        };
        this.currentTerm = {
            uuid: "",
            letter: "",
            term: "",
            definition: "",
            is_advanced: false,
            is_visible: true,
            url: "",
            seo_title: "",
            seo_description: "",
            long_definition: "",
            related_links: [],
        };
        this.currentTermOriginalVisible = true;
    }
    OpenDialog() {
        this.isOpenDialog = !this.isOpenDialog;
        this.newTerm.letter = "";
        this.newTerm.term = "";
        this.newTerm.definition = "";
        this.newTerm.is_advanced = false;
        this.newTerm.is_visible = true;
        this.newTerm.url = "";
        this.newTerm.seo_title = "";
        this.newTerm.seo_description = "";
        this.newTerm.long_definition = "";
        this.newTerm.related_links = [];
        this.newUrlTouched = false;
    }
    OpenEditDialog() {
        this.isOpenEditDialog = !this.isOpenEditDialog;
    }
    onNewTermInput() {
        this.newTerm.letter = this.deriveLetter(this.newTerm.term);
        if (!this.newUrlTouched) {
            this.newTerm.url = UtilGeneral.Slugify(this.newTerm.term);
        }
    }
    onEditTermInput() {
        this.currentTerm.letter = this.deriveLetter(this.currentTerm.term);
        if (!this.editUrlTouched) {
            this.currentTerm.url = UtilGeneral.Slugify(this.currentTerm.term);
        }
    }
    onNewUrlInput() {
        this.newUrlTouched = true;
        this.newTerm.url = UtilGeneral.Slugify(this.newTerm.url || "");
    }
    onEditUrlInput() {
        this.editUrlTouched = true;
        this.currentTerm.url = UtilGeneral.Slugify(this.currentTerm.url || "");
    }
    sanitizeLetter(target) {
        if (!target.letter)
            return;
        target.letter = target.letter.toUpperCase();
    }
    isLetterInvalid(letter) {
        if (!letter)
            return false;
        return !/^[A-Z#]$/.test(letter);
    }
    IsRelatedLinksValid(links) {
        return RelatedLinksEditor.IsValid(links);
    }
    async CreateTerm() {
        this.HasLoading = true;
        const validate = this.NewFormValidate.validate();
        if (!validate) {
            this.HasLoading = false;
            return;
        }
        if (ApiEnter.CurrentSessionUUID != undefined) {
            const created = await ApiGlossary.CreateTerm(ApiEnter.CurrentSessionUUID, {
                ...this.newTerm,
                letter: this.newTerm.letter || this.deriveLetter(this.newTerm.term),
                url: this.newTerm.url || UtilGeneral.Slugify(this.newTerm.term),
                related_links: RelatedLinksEditor.Sanitize(this.newTerm.related_links),
            });
            if (!created) {
                this.HasLoading = false;
                await sweetalert({
                    title: this.$t("general.error"),
                    text: this.$t("general.request_error"),
                    icon: "info",
                });
                return;
            }
            const createdUuid = typeof created === "string" ? created : undefined;
            if (createdUuid && !this.newTerm.is_visible) {
                await ApiGlossary.ToggleVisibility(ApiEnter.CurrentSessionUUID, createdUuid, 0);
            }
            this.OpenDialog();
            sweetalert({
                title: this.$t("general.success"),
                text: this.$t("general.success_created"),
                icon: "success",
            });
            await this.GetGlossary();
        }
        this.HasLoading = false;
    }
    async ChangeTermVisibility(item) {
        try {
            const response = await ApiGlossary.ToggleVisibility(ApiEnter.CurrentSessionUUID, item.uuid, item.is_visible ? 1 : 0);
            if (response) {
                sweetalert({
                    title: this.$t("general.success"),
                    text: this.$t("general.success_updated"),
                    icon: "success",
                });
                this.GetGlossary();
            }
            else {
                await sweetalert({
                    title: this.$t("general.error"),
                    text: this.$t("general.request_error"),
                    icon: "info",
                });
            }
        }
        catch (e) {
            console.error(e);
            await sweetalert({
                title: this.$t("general.error"),
                text: this.$t("general.request_error"),
                icon: "info",
            });
        }
    }
    async ChangeTermAdvanced(item) {
        try {
            const response = await ApiGlossary.UpdateTerm(ApiEnter.CurrentSessionUUID, {
                ...item,
                letter: item.letter || this.deriveLetter(item.term),
                url: item.url || UtilGeneral.Slugify(item.term),
            });
            if (response) {
                sweetalert({
                    title: this.$t("general.success"),
                    text: this.$t("general.success_updated"),
                    icon: "success",
                });
                this.GetGlossary();
            }
            else {
                await sweetalert({
                    title: this.$t("general.error"),
                    text: this.$t("general.request_error"),
                    icon: "info",
                });
            }
        }
        catch (e) {
            console.error(e);
            await sweetalert({
                title: this.$t("general.error"),
                text: this.$t("general.request_error"),
                icon: "info",
            });
        }
    }
    async ChangeTerm() {
        this.HasLoading = true;
        try {
            const wasVisible = this.currentTermOriginalVisible;
            const response = await ApiGlossary.UpdateTerm(ApiEnter.CurrentSessionUUID, {
                ...this.currentTerm,
                letter: this.currentTerm.letter || this.deriveLetter(this.currentTerm.term),
                url: this.currentTerm.url || UtilGeneral.Slugify(this.currentTerm.term),
                related_links: RelatedLinksEditor.Sanitize(this.currentTerm.related_links),
            });
            if (response) {
                if (wasVisible !== this.currentTerm.is_visible) {
                    await ApiGlossary.ToggleVisibility(ApiEnter.CurrentSessionUUID, this.currentTerm.uuid, this.currentTerm.is_visible ? 1 : 0);
                }
                sweetalert({
                    title: this.$t("general.success"),
                    text: this.$t("general.success_updated"),
                    icon: "success",
                });
                this.OpenEditDialog();
                this.GetGlossary();
            }
            else {
                await sweetalert({
                    title: this.$t("general.error"),
                    text: this.$t("general.request_error"),
                    icon: "info",
                });
            }
        }
        catch (e) {
            console.error(e);
            await sweetalert({
                title: this.$t("general.error"),
                text: this.$t("general.request_error"),
                icon: "info",
            });
        }
        this.HasLoading = false;
    }
    async openEditDialog(data) {
        this.currentTerm.uuid = data.uuid;
        this.currentTerm.letter = data.letter;
        this.currentTerm.term = data.term;
        this.currentTerm.definition = data.definition;
        this.currentTerm.is_advanced = data.is_advanced;
        this.currentTerm.is_visible = data.is_visible;
        const hasExistingUrl = !!(data.url && data.url.length > 0);
        this.currentTerm.url = hasExistingUrl ? data.url : UtilGeneral.Slugify(data.term || "");
        this.currentTerm.seo_title = data.seo_title || "";
        this.currentTerm.seo_description = data.seo_description || "";
        this.currentTerm.long_definition = data.long_definition || "";
        this.currentTerm.related_links = Array.isArray(data.related_links) ? data.related_links.map(link => ({ ...link })) : [];
        this.editUrlTouched = hasExistingUrl;
        this.currentTermOriginalVisible = data.is_visible;
        this.OpenEditDialog();
    }
    DeleteTerm(uuid) {
        sweetalert({
            title: this.$t("general.confirm"),
            text: this.$t("glossary.accept_delete"),
            icon: "warning",
            buttons: [this.$t("general.no"), this.$t("general.yes")],
        }).then(async (isConfirm) => {
            if (isConfirm == true) {
                const response = await ApiGlossary.DeleteTerm(ApiEnter.CurrentSessionUUID, uuid);
                if (response) {
                    sweetalert({
                        title: this.$t("general.success"),
                        text: this.$t("general.success_deleted"),
                        icon: "success",
                    });
                    this.GetGlossary();
                }
                else {
                    await sweetalert({
                        title: this.$t("general.error"),
                        text: this.$t("general.request_error"),
                        icon: "info",
                    });
                }
            }
        });
    }
    async GetGlossary() {
        try {
            const data = await ApiGlossary.GetGlossary(ApiEnter.CurrentSessionUUID);
            if (!data) {
                this.TableItems = [];
                return;
            }
            const flat = [];
            if (data.letters) {
                Object.keys(data.letters).forEach(letter => {
                    (data.letters[letter] || []).forEach(item => {
                        flat.push({
                            uuid: item.uuid,
                            letter: letter,
                            term: item.term,
                            definition: item.definition,
                            is_advanced: false,
                            is_visible: item.is_visible !== undefined ? !!item.is_visible : true,
                            url: item.url,
                            seo_title: item.seo_title,
                            seo_description: item.seo_description,
                            long_definition: item.long_definition,
                            related_links: Array.isArray(item.related_links) ? item.related_links : [],
                        });
                    });
                });
            }
            if (data.advanced) {
                data.advanced.forEach(item => {
                    flat.push({
                        uuid: item.uuid,
                        letter: this.deriveLetter(item.term),
                        term: item.term,
                        definition: item.definition,
                        is_advanced: true,
                        is_visible: item.is_visible !== undefined ? !!item.is_visible : true,
                        url: item.url,
                        seo_title: item.seo_title,
                        seo_description: item.seo_description,
                        long_definition: item.long_definition,
                        related_links: Array.isArray(item.related_links) ? item.related_links : [],
                    });
                });
            }
            this.TableItems = flat;
        }
        catch (e) {
            console.error(e);
        }
    }
    deriveLetter(term) {
        if (!term)
            return "#";
        const first = term.charAt(0).toUpperCase();
        return /^[A-Z]$/.test(first) ? first : "#";
    }
    CanAdminAccess() {
        return this.GetCurrentSessionUser != undefined && this.GetCurrentSessionUser.system_role == EUserEnum.SystemRole.SuperAdmin;
    }
    created() {
        this.GetGlossary();
    }
};
__decorate([
    Ref("new-form")
], Glossary.prototype, "NewFormValidate", void 0);
__decorate([
    Getter("getCurrentSessionUser")
], Glossary.prototype, "GetCurrentSessionUser", void 0);
Glossary = __decorate([
    Component({
        components: { PageHeader, StandartTemplate, LeftMenuTab, CKEditor, RelatedLinksEditor },
    })
], Glossary);
export default Glossary;
